import Resource from './Resource';

export default class TestTaker extends Resource {
	constructor(options={}) {
		let {
			route = `STM/test/:testRid/:action`,
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data:data
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
    }
    
    post() {
		return this.request('post');
    }
    
}
